import { makeStyles, Theme } from '@material-ui/core';

export const useFunctionArgumentsStyles = makeStyles<Theme>((theme) => ({
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    borderRadius: '12px',
    background: 'var(--color-black-3)',
    padding: '24px',
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '20px',
    color: '#FAFAFA',
    marginBottom: 16,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      marginBottom: 12,
    },
  },
  contractInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: 24,
  },
  contractIcon: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #0092C7 -0.19%, #00C261 100.11%)',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  functionName: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: '20px',
    color: '#FAFAFA',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  contractAddr: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    color: '#ABABAB',
    [theme.breakpoints.down('sm')]: {
      fontSize: 13,
    },
  },
  separator: {
    borderColor: '#FFFFFF1A',
    marginBottom: '16px',
  },
  arguments: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    color: '#ABABAB',
  },
  arg: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  argValue: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '4px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '80%',
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '70%',
      textAlign: 'right',
    },
  },
  argName: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '20px',
    color: '#ABABAB',
  },
  argType: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    color: '#ABABAB',
  },
  plainArg: {
    color: '#FAFAFA',
    wordBreak: 'break-all',
  },
  numericArg: {
    color: '#FAFAFA',
    textShadow: '0 0 6px rgba(108, 95, 255, 1)',
  },
  principalArg: {
    color: '#FAFAFA',
    backgroundSize: '100%',
    backgroundRepeat: 'repeat',
    backgroundImage: 'linear-gradient(92.01deg, #C3BEFF 0%, #9B93FF 100%)',
    backgroundClip: 'text',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'transparent',
    '-moz-background-clip': 'text',
    '-moz-text-fill-color': 'transparent',
    textShadow: '0 0 6px rgba(108, 95, 255, 1)',
    [theme.breakpoints.down('sm')]: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      maxWidth: '90%',
    },
  },
}));
